import script from "./PerfilUsuarioView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerfilUsuarioView.vue?vue&type=script&setup=true&lang=ts"

import "./PerfilUsuarioView.vue?vue&type=style&index=0&id=57ef95df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ef95df"]])

export default __exports__